// extracted by mini-css-extract-plugin
export default {"wrapperCard":"CardLecture_wrapperCard__o+qeG","icon":"CardLecture_icon__4dJIK"};